import { configureStore } from '@reduxjs/toolkit';
import deviceReducer from './deviceReducer';
import detailsReducer from './detailsReducer';
import userReducer from "./userSlice";
const store = configureStore({
  reducer: {
    devices: deviceReducer,
    details: detailsReducer,
    user: userReducer,
  },
});

export default store;